import { DefaultPassThrough } from '@primevue/core'
import type { GalleriaDesignTokens } from '@primeuix/themes/types/galleria'
import { GalleriaPassThroughOptions } from 'primevue/galleria'

const buttonClasses =
  '!tw-static tw-shrink-0 !tw-border-1 !tw-border-border hover:!tw-border-border-hover !tw-shadow-button'

export const GalleriaPassThroughConfig: DefaultPassThrough<GalleriaPassThroughOptions> = {
  thumbnailItems: {
    class: 'tw-flex tw-gap-2 !tw-justify-center'
  },
  thumbnails: {
    class: 'tw-items-center'
  },
  thumbnailItem: {
    class: '!tw-opacity-100 !tw-flex-none'
  },
  items: {
    class: 'tw-flex tw-items-center tw-gap-2'
  },
  itemsContainer: {
    class: 'tw-relative tw-flex-1'
  },
  nextButton: {
    class: buttonClasses
  },
  prevButton: {
    class: buttonClasses
  }
}

export const GalleriaStyleConfig: GalleriaDesignTokens = {
  root: {
    borderWidth: '0px',
    borderRadius: '0px'
  },
  navButton: {
    size: '36px',
    background: 'var(--color-surface-default)',
    color: 'var(--icon-default)',
    hoverBackground: 'var(--action-secondary-hover)',
    hoverColor: 'var(--icon-default)'
  },
  navIcon: {
    size: '20px'
  }
}

export { default as ImageCarousel } from './ImageCarousel.vue'
